import { BodyRegular } from '@common/body';
import Button from '@common/Button/Button';
import Icon from '@common/Icons/Icon';

type Props = {
  articleUrl: string;
};

export const ShareArticleButtons = ({ articleUrl }: Props): JSX.Element => (
  <div className="flex flex-row items-center">
    <div className="mr-[20px] text-blue">
      <BodyRegular>SHARE THIS STORY</BodyRegular>
    </div>
    <div className="mr-2">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${articleUrl}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          colour="White"
          type="Primary"
          fullWidth={false}
          icon={<Icon name="meta" />}
        />
      </a>
    </div>
    <a
      href={`https://twitter.com/share?url=${articleUrl}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button
        colour="White"
        type="Primary"
        fullWidth={false}
        icon={<Icon name="twitter" />}
      />
    </a>
  </div>
);
